import * as React from 'react';
import CompanyParty from './CompanyParty';
import AntTextInput from 'common/components/antHelpers/AntTextInput';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import AntForm from 'common/components/antHelpers/AntForm';
import AntField from 'common/components/antHelpers/AntField';
import style from './CompanyParty.module.scss';
import Flex from 'common/components/Flex';
import { useTranslation } from 'react-i18next';
import AddressFieldView from '../AddressField/AddressFieldView';
import AddressField from '../AddressField/AddressField';
import { PartyDto } from 'model/Api/Parties/Model/PartyDto';
import Trash from 'common/icons/trash-2.svg';
import ConfirmationModalView from '../ConfirmationModal/ConfirmationModalView';

interface CompanyPartyViewProps {
    model: CompanyParty;
    close: (p?: PartyDto) => void;
}

const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
};

const CompanyPartyView: React.FC<CompanyPartyViewProps> = observer(
    ({ model, close }) => {
        const { t } = useTranslation([
            'userAddresses',
            'common',
            'addressField',
            'membership'
        ]);

        return (
            <>
                <AntForm form={model.partyForm} {...formLayout}>
                    {(fields) => (
                        <>
                            <h2 className={style.subtitle}>
                                {t('membership:selectCompanyAddress')}
                            </h2>
                            <div className={style.fields}>
                                <AntField
                                    field={fields.name}
                                    label={t('userAddresses:companyName')}
                                    className={style.inputField}>
                                    {(props) => <AntTextInput {...props} />}
                                </AntField>
                                <AntField
                                    field={fields.careOf}
                                    label={t('addressField:companyTo')}
                                    className={style.inputField}>
                                    {(props) => <AntTextInput {...props} />}
                                </AntField>
                                <AntField
                                    field={fields.orgNo}
                                    label={t('addressField:organisationNumber')}
                                    className={style.inputField}>
                                    {(props) => {
                                        return (
                                            <AntTextInput
                                                {...props}
                                                value={model.getOnlyNumbers(props.value)}
                                                onChange={(value) => {
                                                    const filtered = model.getOnlyNumbers(value);
                                                    props.onChange?.(filtered);
                                                }}
                                            />
                                        );
                                    }}
                                </AntField>
                                <AddressFieldView
                                    model={fields.address as AddressField}
                                />
                            </div>

                            {model.isEdited && (
                                <button
                                    className={style.removeAddress}
                                    onClick={() => model.requestDelete(close)}>
                                    <img
                                        src={Trash}
                                        alt={t('userAddresses:removeAddress')}
                                    />
                                    <span>
                                        {t('userAddresses:removeAddress')}
                                    </span>
                                </button>
                            )}
                            <Flex
                                justifyContent={'center'}
                                customClass={style.buttons}>
                                <Button
                                    className={style.btn}
                                    type={'default'}
                                    onClick={() => close()}>
                                    {t('common:cancel')}
                                </Button>
                                <Button
                                    className={style.btn}
                                    type={'primary'}
                                    onClick={() => model.save()}
                                    disabled={model.partyForm.isPristine}>
                                    {t('common:save')}
                                </Button>
                            </Flex>
                        </>
                    )}
                </AntForm>
                {model.deleteConfirmation && (
                    <ConfirmationModalView
                        dialog={model.deleteConfirmation}
                        title={t('userAddresses:dialogDelete')}
                        okText={t('common:delete')}>
                        <span>{t('userAddresses:deleteConfirmation')}</span>
                    </ConfirmationModalView>
                )}
            </>
        );
    }
);

export default CompanyPartyView;
